/**
 * sessionStorage keys for the search sort selection.
 *
 * These carry a version because the stored value wins over the index the page
 * asks for: `Page.tsx` and `AutocompleteBox.tsx` both prefer the stored sort
 * over `indexName`. A returning visitor with an old value stays pinned to the
 * index they were on before a deploy — which is exactly the population that
 * reported search returning stale results.
 *
 * Bumping the version is preferable to clearing on load. It is one change, it
 * cannot race with somebody mid-session, and the old keys expire with the
 * session anyway.
 *
 * Bump the suffix whenever the default index changes.
 */
export const SORT_KEY = 'sort.v2';
export const SORT_INITIALIZED_KEY = 'sortInitialized.v2';
